
export const featurePaths = {
    ShowList: "/showlist",
    CreateShow: "/showlist/createshow",
    EditShow: "/showlist/updateshow",

} as const;

export const apiPaths = {} as const;
